import { Box } from "@mui/material";
import { formatPhone } from "@/utils/StringUtils";
import { useCheckoutUI } from "../../../CheckoutUIProvider";

import { TABLET_SCREEN_SIZE } from "@brandclub/common-ui";

const CheckoutAccountInfo = () => {
  const [state] = useCheckoutUI();

  return (
    <Box
      sx={{
        fontSize: 16,
        [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
          fontSize: 14,
        },
      }}
    >
      <div style={{}}>
        {state.context.checkoutIntent?.accountInformation?.firstName && (
          <div style={{ marginBottom: "8px" }}>
            {state.context.checkoutIntent?.accountInformation?.firstName}{" "}
            {state.context.checkoutIntent?.accountInformation?.lastName}
          </div>
        )}
        <div>
          {formatPhone(
            state.context.checkoutIntent?.accountInformation?.phoneNumber || ""
          )}
        </div>
      </div>
    </Box>
  );
};

export default CheckoutAccountInfo;
